var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-promo-btn"},[_vm._t("default",null,{"promoCode":_vm.promoCode,"applyPromo":_vm.addPromoTotCart,"applying":_vm.applying,"promoIsApplied":_vm.promoIsApplied,"errMessage":_vm.errMessage})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }